import * as Sentry from '@sentry/react';

export const initSentryFrontend = () => {
    Sentry.init({
      dsn: "https://3c3d3d50574bf0c91f789d7acab7fc30@o4508601357959168.ingest.de.sentry.io/4508601362874448",
      integrations: [
        Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    });
};